import { render } from "./ServiciosList.vue?vue&type=template&id=211a33ea&scoped=true"
import script from "./ServiciosList.vue?vue&type=script&lang=js"
export * from "./ServiciosList.vue?vue&type=script&lang=js"

import "./ServiciosList.vue?vue&type=style&index=0&id=211a33ea&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211a33ea"]])

export default __exports__